import {fetchUserTickets} from '../endpoints/api';
import {useQuery} from '@tanstack/react-query';

export function useFetchUserTickets(enabled = true) {
  return useQuery(['user-tickets'], () => fetchUserTickets(), {
    enabled: enabled,
  });
}
